<template>
  <div class="date-picker">
    <v-menu
      v-model="pickerVisible"
      :close-on-content-click="false"
      :nudge-right="leftOffset"
      :disabled="disabled"
      transition="scale-transition"
      min-width="290px"
      offset-y
      full-width
      lazy
    >
      <v-text-field
        slot="activator"
        v-bind="$attrs"
        :value="value"
        :label="label"
        :prepend-icon="prependIcon"
        :clearable="clearable"
        :disabled="disabled"
        readonly
        @click:clear="onClearIconClick"
      />

      <v-date-picker
        :value="value"
        :min="min"
        :max="max"
        :allowed-dates="allowedDates"
        no-title
        scrollable
        @input="onDateInput"
      />
    </v-menu>
  </div>
</template>

<script>
  export default {
    name: 'DatePicker',
    inheritAttrs: false,
    props: {
      value: {
        type: String,
        default: undefined
      },
      label: {
        required: true,
        type: String
      },
      min: {
        type: String,
        default: ''
      },
      max: {
        type: String,
        default: ''
      },
      prependIcon: {
        type: String,
        default: ''
      },
      allowedDates: {
        type: Function,
        default: null
      },
      clearable: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        pickerVisible: false
      }
    },
    computed: {
      leftOffset () {
        const offset = 33
        return this.prependIcon ? offset : ''
      }
    },
    methods: {
      onDateInput (date) {
        this.setPickerVisible(false)
        this.$emit('input', date)
      },
      onClearIconClick () {
        this.$emit('input', '')
      },
      setPickerVisible (value) {
        this.$set(this, 'pickerVisible', value)
      }
    }
  }
</script>
